import { useAsyncState } from "@vueuse/core"
import { useField } from "vee-validate"
import { computed, ref, unref, watch, watchEffect } from "vue"
import { CiselnikBasicResponse } from "../client-portal"
import { skSelectOption } from "../constants"
import { getPSC, getUlica, getKraj, getObec, getObecByStat, getOkres, getStat } from "./callableApi"

export function useDynamicAddress(prefix?: string) {
  const customPrefix = prefix ? `${prefix}.` : ''
  const { setValue: setValueSkSelected } = useField(`${customPrefix}.isSkSelected`)
  const { setValue: setValueHasObecList } = useField(`${customPrefix}.hasObecList`)
  const { value: formStat } = useField(`${customPrefix}.stat`)
  const { value: formKraj, setValue: setValueKraj } = useField(`${customPrefix}.kraj`)
  const { value: formOkres, setValue: setValueOkres } = useField(`${customPrefix}.okres`)
  const { value: formObec, setValue: setValueObec } = useField(`${customPrefix}.obec`)
  const { value: formUlica, setValue: setValueUlica } = useField(`${customPrefix}.ulica`)
  const { value: formPsc, setValue: setValuePSC } = useField(`${customPrefix}.psc`)
  const { setValue: setValueObecNazov } = useField(`${customPrefix}.obecNazov`)

  // We need this so first load will not delete defined values
  const loaded = ref<boolean>(false)

  const kraj = ref<CiselnikBasicResponse[]>([])
  const okres = ref<CiselnikBasicResponse[]>([])
  const obec = ref<CiselnikBasicResponse[]>([])
  const ulica = ref<{id: string, nazov: string}[]>([])
  const psc = ref<{id: string, nazov: string}[]> ([])

  const isSkSelected = ref<boolean>(false)

  const { state: stat } = useAsyncState(getStat(), [])

  watch([formStat, formKraj, formOkres, formObec, formUlica, formPsc], async ([statNew, krajNew, okresNew, obecNew, ulicaNew, pscNew], [statOld, krajOld, okresOld, obecOld, ulicaOld, pscOld]) => {
    isSkSelected.value = statNew?.id === skSelectOption?.id
    setValueSkSelected(isSkSelected.value)


    if (isSkSelected.value) {
      if (statNew && statNew !== statOld) {
        if(loaded.value) {
          kraj.value = await getKraj(statNew?.id)
          setValueKraj(undefined)
          okres.value = []
          setValueOkres(undefined)
          obec.value = []
          setValueObec(undefined)
          setValueObecNazov(undefined)
        } else {
          kraj.value = await getKraj(statNew?.id)
        }
      }


      if (krajNew && krajNew !== krajOld) {
        if(loaded.value) {
          okres.value = await getOkres(krajNew?.id)
          setValueOkres(undefined)
          obec.value = []
          setValueObec(undefined)
          setValueObecNazov(undefined)
          ulica.value = []
          setValueUlica(undefined)
          psc.value = []
          setValuePSC(undefined)
        } else {
          okres.value = await getOkres(krajNew?.id)
        }
      }
      if (okresNew && okresNew !== okresOld) {
        if(loaded.value) {
          obec.value = await getObec(okresNew?.id)
          setValueObec(undefined)
          setValueObecNazov(undefined)
          ulica.value = []
          setValueUlica(undefined)
          psc.value = []
          setValuePSC(undefined)
        } else {
          obec.value = await getObec(okresNew?.id)
        }
      }

      if (obecNew /*&& obecNew !== obecOld*/) {

        if(loaded.value) {
          ulica.value = await getUlica(obecNew?.id)
       //   setValueUlica(undefined)
          psc.value = await getPSC(obecNew?.id, undefined, undefined, formUlica.value)
       //   setValuePSC(undefined)
        } else {
          ulica.value = await getUlica(obecNew?.id, undefined, formUlica.value)
          psc.value = await getPSC(obecNew?.id, undefined, formPsc.value, formUlica.value)
        }
      }


      if(!ulicaNew && !!obecNew && loaded.value) {

        psc.value = await getPSC(obecNew?.id, undefined, undefined, formUlica.value)
        if(pscOld === pscNew) {
          setValuePSC(undefined)
        }
      }

      if(ulicaNew /*&& ulicaNew !== ulicaOld*/) {
        if(loaded.value) {
          psc.value = await getPSC(obecNew?.id, undefined, undefined, formUlica.value)
        //  setValuePSC(undefined)
        } else {
          psc.value = await getPSC(obecNew?.id, undefined, formPsc.value, formUlica.value)
        }
      }

      // slovensko ma urcite zoznam obci
      setValueHasObecList(true)
    } else {
      if (statNew && statNew !== statOld) {
        if(loaded.value) {
          kraj.value = []
          setValueKraj(undefined)
          okres.value = []
          setValueOkres(undefined)
          obec.value = await getObecByStat(statNew?.id)
          setValueObec(undefined)
          setValueObecNazov(undefined)
          setValuePSC(undefined)
          setValueUlica(undefined)
        } else {
          obec.value = await getObecByStat(statNew?.id)
        }
      }
      // zahranicne nemusia mat obec ale mozu
      setValueHasObecList(obec.value?.length > 0)
    }
    if(!loaded.value) {
      loaded.value = true
    }
  })

  return { stat, kraj, okres, obec, ulica, psc, isSkSelected }
}
